import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroCinematic from "../components/HeroCinematic";
import {
  ProductCategoriesSection,
  WhyChooseSection,
  ApplicationsSection,
  DealerCTASection,
  ProjectShowcase,
} from "../components/HomeSections";
import BrochureSection from "../components/BrochureSection";
import BlogSection from "../components/BlogSection";
import TrustedComponentsSection from "../components/TrustedComponentsSection";
import FAQSection from "../components/FAQSection";
import CTABanner from "../components/CTABanner";
import LiveInstallationGallery from "../components/LiveInstallationGallery";
import Seo, { buildBreadcrumb } from "../components/Seo";
import { PAGE_SEO } from "../data/seo";

export default function Home() {
  const seo = PAGE_SEO.home;
  return (
    <>
      <Seo
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        path={seo.path}
        image={seo.image}
        jsonLd={[buildBreadcrumb([{ name: "Home", path: "/" }])]}
        jsonLdId="home"
      />
      <Navbar />
      <main>
        <HeroCinematic />
        <div id="home-product-categories" data-testid="home-product-categories">
          <ProductCategoriesSection />
        </div>
        <LiveInstallationGallery />
        <WhyChooseSection />
        <ApplicationsSection />
        <DealerCTASection />
        <ProjectShowcase />
        <TrustedComponentsSection />
        <BrochureSection />
        <BlogSection />
        <FAQSection />
        <CTABanner
          headline="Ready to Build with Confidence?"
          description="From residential towers to industrial megaprojects, LIFTILE delivers reliable construction machinery engineered for performance, safety and long-term value."
        />
      </main>
      <Footer />
    </>
  );
}
